module.exports = __webpack_public_path__ + "static/media/01B.a71c985e.png";